import React from 'react';
import { useQuery } from 'react-fetching-library';
import { IconButton, Stack, Card, CardContent, Typography } from '@mui/material';
import { getSurveysAction, getJsonFormsAction } from '../../../services/request';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { formatDateTime } from '../../../services/functions';
import SurveyPreview from './SurveyPreview';

export default function SurveyList({ id }) {
  const { payload, loading, error } = useQuery(getSurveysAction(id));
  const { payload: jFPayload, loading: jFLoading, error: jFError } = useQuery(getJsonFormsAction(id));
  const [data, setData] = React.useState(null);
  const [surveys, setSurveys] = React.useState([]);
  const [jsonSchema, setJsonSchema] = React.useState({});
  const [schemaUI, setSchemaUI] = React.useState({});

  React.useEffect(() => {
    if (!loading && !error) {
      setSurveys(payload);
    }
  }, [loading]);

  React.useEffect(() => {
    if (!jFLoading && !jFError) {
      setJsonSchema(jFPayload.json_schema);
      setSchemaUI(jFPayload.json_schema_ui);
    }
  }, [jFLoading]);


  return (
    <>
      <Stack spacing={2} mt={2}>
        {surveys.map(survey => <Card key={survey.id} sx={{ maxWidth: '500px' }}>
          <CardContent>
            <Stack direction="row" justifyContent="space-between" alignItems="center">
              <Typography>
                Ankieta ({formatDateTime(survey.created_at)})
              </Typography>
              <IconButton color="primary" onClick={() => setData(survey.form_data)}>
                <VisibilityIcon />
              </IconButton>
            </Stack>
          </CardContent>
        </Card>)}
      </Stack>
      {data !== null ? <SurveyPreview handleClose={() => setData(null)} data={data} jsonSchema={jsonSchema} schemaUI={schemaUI}/> : null}
    </>
  );
};
